import React from "react";
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";
import TitansNavbar from "../Components/TitansNavbar";
import TitansHero from "../Components/TitansHero";

function AboutTitans() {
  return (
    <>
      <Navbar2 />
      <TitansHero /> 
      <TitansNavbar />
      {/* About The Titans */}
        <div className="container-fluid">
            <div className='titansTitle text-center pt-5 pb-3'>
              MEET THE TEAM
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 titansRedTitle text-center">
                <p>Tim Porter</p>
              </div>
              <div className="col-12 col-lg-6 lead">
                Tim Porter Photo<br/>
                Owner/President
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 lead text-center">
                Brandon Branch Photo<br/>
                Head Coach/ Basketball Operations
              </div>
              <div className="col-12 col-lg-6 titansRedTitle text-center">
                <p>Brandon Branch</p>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 titansRedTitle text-center">
                <p>John Hollmon</p>
              </div>
              <div className="col-12 col-lg-6 lead">
                John Hollman Photo<br/>
                Director of Player Development
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 lead text-center">
                Brian Hall Photo<br/>
                Assistant Coach
              </div>
              <div className="col-12 col-lg-6 titansRedTitle text-center">
                <p>Brian Hall</p>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 titansRedTitle text-center">
                <p>Kesean Warren</p>
              </div>
              <div className="col-12 col-lg-6 lead">
                Kesean Warren Photo<br/>
                Player development coach
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 lead text-center">
                Rob Stewart Photo<br/>
                Player development coach
              </div>
              <div className="col-12 col-lg-6 titansRedTitle text-center">
                <p>Rob Stewart</p>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 titansRedTitle text-center">
                <p>Albert Rodriguez</p>
              </div>
              <div className="col-12 col-lg-6 lead">
                Albert Rodriguez Photo<br/>
                Team Support
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-6 lead text-center">
                Priscilla Photo<br/>
                Team Support
              </div>
              <div className="col-12 col-lg-6 titansRedTitle text-center">
                <p>Priscilla Perez</p>
              </div>
            </div>
            
        </div>
      <Footer />
    </>
);
}

export default AboutTitans;
